export default [
    {
        /** 退出系统 */
        name: 'queryConfigLists',
        url: '/lists'
    },
    {
        name: 'addConfig',
        url: '/add'
    },
    {
        name: 'updateConfig',
        url: '/update'
    },
    {
        name: 'deleteConfig',
        url: '/delete'
    },
    {
        name: 'queryParentMenus',
        url: '/parentLists'
    }
];
